import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useLocation } from '@reach/router';
import { getFullyAutomaticStructuredData } from '../utils/structuredData';

import HeadSeo from '../components/HeadSeo';
import Header from '../components/Header';
import Layout from '../components/Layout';
import Breadcrumb from '../components/Breadcrumb';

const pagemeta = {
  title: `会社概要 | ホームページ修正・管理のご依頼は有限会社blancへ！他社作成のHPもご相談下さい。`, //このページのタイトルタグに入る情報
  description: `ホームページ制作会社blancは2003年創業、全国対応で1,000サイト超の実績。戦略的デザイン・SEO・保守をワンストップ提供し成果を最大化。明朗料金と迅速サポート、自社完結で安心。会社概要・理念・サービス内容・詳細情報を掲載、無料相談受付中。`, //このページのディスクリプション
  subtitle: `会社概要`, //メインイメージ部分のテキスト
};

const combinedQuery = graphql`
  query CompanyPageQuery {
    site {
      siteMetadata {
        siteUrl
        description
        image
        keyword
        title
      }
    }
  }
`;

export const Head = ({ location }) => {
  const data = useStaticQuery(combinedQuery);

  return (
    <>
      <body className="company" />

      {/* HeadSeoコンポーネント */}
      <HeadSeo pathname={location.pathname} title={pagemeta.title} description={pagemeta.description} keywords={data.site.siteMetadata.keyword} siteMetadata={data.site.siteMetadata} />

      {/* 構造化データスクリプト */}
      <script type="application/ld+json">{JSON.stringify(getFullyAutomaticStructuredData(data.site.siteMetadata, pagemeta.title, pagemeta.description, location, pagemeta.subtitle))}</script>
    </>
  );
};

const company = () => {
  return (
    <>
      <Header />

      <div id="mainimage-sub">
        <h2 className="pagetitle">{pagemeta.subtitle}</h2>
        <p>Company</p>
      </div>
      <Breadcrumb title={pagemeta.subtitle} />

      <Layout>
        <h2>会社概要</h2>
        <table summary="会社概要" className="legal_notice">
          <tbody>
            <tr>
              <th>会社名</th>
              <td>有限会社blanc</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>〒744-0013 山口県下松市栄町3丁目3-14</td>
            </tr>
            <tr>
              <th>設立</th>
              <td>2003年4月</td>
            </tr>
            <tr>
              <th>資本金</th>
              <td>3,000,000円</td>
            </tr>
            <tr>
              <th>役員</th>
              <td>取締役　榮島一博</td>
            </tr>
            <tr>
              <th>事業内容</th>
              <td>ウェブサイト制作・ウェブコンサルティング</td>
            </tr>
            <tr>
              <th>連絡先</th>
              <td>電話 0833-45-3838 FAX 0833-45-3883</td>
            </tr>
            <tr>
              <th>E-mailアドレス</th>
              <td>info@blanc.to</td>
            </tr>
          </tbody>
        </table>

        <h2>特定商取引法に基づく表示</h2>

        <table summary="特定商取引法に基づく表示" className="legal_notice">
          <tbody>
            <tr>
              <th>販売業者名</th>
              <td>有限会社blanc</td>
            </tr>
            <tr>
              <th>販売責任者名</th>
              <td>榮島一博</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>〒744-0013 山口県下松市栄町3丁目3-14</td>
            </tr>
            <tr>
              <th>連絡先</th>
              <td>
                <a href="mailto:info@blanc.to">info@blanc.to</a>
              </td>
            </tr>
            <tr>
              <th>申込の有効期限</th>
              <td>お申し込みより1週間</td>
            </tr>
            <tr>
              <th>お支払い期限</th>
              <td>お打ち合わせ後1週間</td>
            </tr>
            <tr>
              <th>商品引渡し時期</th>
              <td>通常約1ヶ月</td>
            </tr>
            <tr>
              <th>返品について</th>
              <td>お客様都合によるキャンセルはできません。</td>
            </tr>
            <tr>
              <th>支払方法</th>
              <td>銀行振込・PayPal決済</td>
            </tr>
            <tr>
              <th>商品代金以外の必要料金</th>
              <td>消費税</td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  );
};

export default company;
